import { Upload, FileSearch, Tags, CheckCircle2, SendHorizonal, BarChart3, MessageSquare, Shield } from 'lucide-react'
import { useSeo } from '@/lib/useSeo'
import { PageHeader } from '@/components/public/PageHeader'

const capabilities = [
  {
    Icon: Upload,
    title: 'Upload & intake',
    body: 'Lookup or upload the entry document. VICE works with existing document formats.',
  },
  {
    Icon: FileSearch,
    title: 'Text extraction',
    body: 'Text extraction captures the data, while confidence scoring highlights anything that may need review.',
  },
  {
    Icon: Tags,
    title: 'Field bucketing',
    body: 'Extracted values are organized into entry data ready for review and submission, including shipment details, parties, classifications, and duties.',
  },
  {
    Icon: CheckCircle2,
    title: 'Validation & recommendations',
    body: 'HTS codes, entry types, and valuation fields are cross-checked. Inconsistencies surface with an explanation.',
  },
  {
    Icon: MessageSquare,
    title: 'AI chat assistance',
    body: 'The USVI Agent can ask AWA questions about flags, codes, and recommendations without leaving the review surface.',
  },
  {
    Icon: SendHorizonal,
    title: 'Transmit to ACE',
    body: 'Data is reviewed and structured before submission to ACE. Every submission is recorded and saved for tracking.',
  },
  {
    Icon: BarChart3,
    title: 'USVI specific reporting',
    body: 'Volume, category, and compliance reporting streams tailored to VIDF monitoring and risk-targeting analytics.',
  },
  {
    Icon: Shield,
    title: 'Security by default',
    body: 'Row level security, least privilege roles, encrypted storage, and OWASP ZAP baseline scans in CI.',
  },
]

export function Features() {
  useSeo({
    title: 'Features',
    description:
      'VICE features: AI workflow automation, review support, protected transmission to ACE, USVI specific reports, case management, and security by default.',
  })
  return (
    <>
      <PageHeader
        eyebrow="Features"
        title="Everything the USVI Agent needs."
        lede="A focused toolkit for entry summary capture, validation, protected transmission to ACE, case management, and USVI specific reports."
      />
      <section className="relative overflow-hidden max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <img
          src="/logo-sym.png"
          alt=""
          aria-hidden="true"
          className="pointer-events-none select-none absolute -right-24 -top-12 w-[460px] max-w-[55vw] opacity-[0.06] hidden md:block"
        />
        <img
          src="/logo-sym.png"
          alt=""
          aria-hidden="true"
          className="pointer-events-none select-none absolute -left-32 bottom-0 w-[380px] max-w-[40vw] opacity-[0.04] hidden lg:block rotate-12"
        />
        <div className="relative grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {capabilities.map(({ Icon, title, body }) => (
            <article
              key={title}
              className="bg-white rounded-lg border border-neutral-200 p-6 shadow-sm hover:shadow-md transition"
            >
              <div className="inline-flex p-3 rounded bg-secondary-lightest text-secondary">
                <Icon size={22} aria-hidden="true" />
              </div>
              <h2 className="mt-4 text-lg font-bold text-primary">{title}</h2>
              <p className="mt-2 text-sm text-neutral-700 leading-relaxed">{body}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  )
}
